import { shallow } from 'zustand/shallow';

import {
  BackgroundActivity,
  BackgroundActivityTargetKind,
  BackgroundJobActivityTarget,
  serializeActivityTarget
} from '@models/backgroundActivities';
import { useBackgroundActivityStore } from '@services/backgroundActivityStore';

export function useBackgroundActivity(
  target: BackgroundJobActivityTarget | null
): BackgroundActivity | null {
  const targetKey = target ? serializeActivityTarget(target) : null;
  return useBackgroundActivityStore((s) => {
    if (!targetKey) return null;
    const id = s.byTargetKey[targetKey];
    return id ? (s.activities[id] ?? null) : null;
  });
}

export function useBackgroundActivitiesForTask(taskEntityId: string): BackgroundActivity[] {
  return useBackgroundActivityStore(
    (s) =>
      Object.values(s.activities).filter((a) => {
        const t = a.target;
        return (
          (t.kind === BackgroundActivityTargetKind.TASK_BLOCK_CONTENT ||
            t.kind === BackgroundActivityTargetKind.TASK_BLOCK_FILE_SLOT ||
            t.kind === BackgroundActivityTargetKind.TASK_BLOCK_STATIC_ATTACHMENTS) &&
          t.taskEntityId === taskEntityId
        );
      }),
    shallow
  );
}

export function useBackgroundActivitiesForBlock(
  taskEntityId: string,
  blockEntityId: string | null
): BackgroundActivity[] {
  return useBackgroundActivityStore(
    (s) =>
      blockEntityId
        ? Object.values(s.activities).filter((a) => {
            const t = a.target;
            return (
              t.kind === BackgroundActivityTargetKind.TASK_BLOCK_CONTENT &&
              t.taskEntityId === taskEntityId &&
              t.blockEntityId === blockEntityId
            );
          })
        : [],
    shallow
  );
}
